export default "__VITE_ASSET__d751c1c7__"